/*
 *
 * FlowTemplate
 *
 * @version 1.0.0
 * @author Giorgia Cuozzo
 * @since 05-Sep-2024
*/

import { connect } from 'react-redux'
import FlowTemplate from './FlowTemplate'
import { bindActionCreators } from 'redux'
import { doShowPopup, doHidePopup } from 'Store/actions/popup'
import { doHideToast } from 'Store/actions/toast'
import linksConfig from 'Utility/linksConfig'
import componentConfig from 'Utility/globalConfig'
import { Capacitor } from '@capacitor/core'
import formattedMessage from './languageModule'
import { push } from 'redux-first-history'

const mapDispatchToProps = dispatch => ({
  ...bindActionCreators({ doShowPopup, doHidePopup }, dispatch),
  ...bindActionCreators({ doHideToast }, dispatch),
  push: (path) => dispatch(push(path))
})

const getFooterLinks = (pushAction) => [
  { key: 'trasparency', id: 'trasparency', label: formattedMessage.transparency, path: linksConfig.transparency, isExternal: true, newTab: true },
  { key: 'privacy', id: 'privacy', label: formattedMessage.privacy, path: linksConfig.privacy, isExternal: true, newTab: true },
  ...(Capacitor.isNativePlatform()
    ? []
    : [{
        key: 'cookies',
        id: 'cookies',
        label: formattedMessage.cookies,
        ...componentConfig.cookiePolicy.getCookieConfig(linksConfig)
      }]),
  {
    key: 'siteMap',
    id: 'siteMap',
    label: formattedMessage.siteMap,
    path: '/sitemap',
    action: () => pushAction('/sitemap'),
    isExternal: false,
    newTab: false
  }
]

const mapStateToProps = (state) => ({
  bank: process.env.BANK === 'NEXIBUSINESS' ? 'NEXI' : process.env.BANK,
  logoType: 'default',
  logoTypeMobile: 'default'
})

export default connect(
  mapStateToProps,
  mapDispatchToProps,
  (stateProps, dispatchProps, ownProps) => ({
    ...stateProps,
    ...ownProps,
    footerLinks: getFooterLinks(dispatchProps.push),
    actions: dispatchProps
  })
)(FlowTemplate)
